import * as React from "react";
import { StatusBadge as BaseStatusBadge } from "@/components/ui/status-badge";

interface StatusBadgeProps {
  status: 'completed' | 'processing' | 'error';
  className?: string;
  showIcon?: boolean;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '', showIcon = true }) => {
  return (
    <BaseStatusBadge 
      status={status} 
      showIcon={showIcon}
      className={className}
    />
  );
};

export default StatusBadge;
